class SplitOptionPicker {
  constructor(variantPicker) {
    this.vp = variantPicker;
    variantPicker._splitOptionPicker = this;

    this.splitUIs = Array.from(variantPicker.querySelectorAll('.split-option-ui'));
    if (this.splitUIs.length === 0) return;

    this.splitUIs.forEach((ui) => this.initUI(ui));
  }

  initUI(ui) {
    const primaryGroup = ui.querySelector('[data-split-part="primary"]');
    const secondaryGroup = ui.querySelector('[data-split-part="secondary"]');

    if (!primaryGroup || !secondaryGroup) return;

    this.filterSecondary(ui);

    const primarySelect = primaryGroup.querySelector('custom-select');
    if (primarySelect) {
      primarySelect.addEventListener('change', (evt) => {
        evt.stopPropagation();
        this._syncSelectToRadio(primaryGroup, primarySelect);
        this.filterSecondary(ui);
        this.syncHiddenSelector(ui);
      });
    } else {
      primaryGroup.addEventListener('change', (evt) => {
        evt.stopPropagation();
        this.filterSecondary(ui);
        this.syncHiddenSelector(ui);
      });
    }

    secondaryGroup.addEventListener('change', (evt) => {
      evt.stopPropagation();
      this.syncHiddenSelector(ui);
    });
  }

  _syncSelectToRadio(primaryGroup, primarySelect) {
    const selectedOption = primarySelect.querySelector('.custom-select__option[aria-selected="true"]');
    const value = selectedOption?.dataset.value;
    if (value == null) return;
    const radio = primaryGroup.querySelector(`input[value="${CSS.escape(value)}"]`);
    if (radio && !radio.checked) radio.checked = true;
  }

  _getPrimaryValue(primaryGroup) {
    const primarySelect = primaryGroup.querySelector('custom-select');
    if (primarySelect) {
      const selectedOption = primarySelect.querySelector('.custom-select__option[aria-selected="true"]');
      if (selectedOption) return selectedOption.dataset.value;
    }
    return primaryGroup.querySelector('input[type="radio"]:checked')?.value || null;
  }

  filterSecondary(ui) {
    const primaryGroup = ui.querySelector('[data-split-part="primary"]');
    const secondaryGroup = ui.querySelector('[data-split-part="secondary"]');

    const selectedPrimaryValue = this._getPrimaryValue(primaryGroup);
    const secondaryInputs = Array.from(secondaryGroup.querySelectorAll('input[type="radio"]'));

    if (!selectedPrimaryValue) {
      secondaryInputs.forEach((input) => {
        input.disabled = false;
        const label = secondaryGroup.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (label) label.classList.remove('split-opt--hidden');
      });
      return;
    }

    const currentChecked = secondaryGroup.querySelector('input[type="radio"]:checked');
    let firstCompatible = null;
    let currentStillValid = false;

    secondaryInputs.forEach((input) => {
      const compatList = (input.dataset.compatibleWith || '').split('|||').filter(Boolean);
      const isCompatible = compatList.includes(selectedPrimaryValue);
      const label = secondaryGroup.querySelector(`label[for="${CSS.escape(input.id)}"]`);

      if (isCompatible) {
        input.disabled = false;
        if (label) label.classList.remove('split-opt--hidden');
        if (!firstCompatible) firstCompatible = input;
        if (input === currentChecked) currentStillValid = true;
      } else {
        input.disabled = true;
        if (label) label.classList.add('split-opt--hidden');
      }
    });

    if (!currentStillValid && firstCompatible) {
      firstCompatible.checked = true;
    }
  }

  syncHiddenSelector(ui) {
    const primaryGroup = ui.querySelector('[data-split-part="primary"]');
    const secondaryGroup = ui.querySelector('[data-split-part="secondary"]');

    const primaryValue = this._getPrimaryValue(primaryGroup);
    const selectedSecondary = secondaryGroup.querySelector('input[type="radio"]:not([disabled]):checked')
      || secondaryGroup.querySelector('input[type="radio"]:not([disabled])');

    if (!primaryValue || !selectedSecondary) return;

    const secondaryValue = selectedSecondary.value;
    const separator = ui.dataset.splitSeparator || '/';

    const realOptionName = ui.dataset.splitRealOption;
    const hiddenSelector = this.vp.querySelector(
      `.option-selector[data-option="${CSS.escape(realOptionName)}"]`
    );
    if (!hiddenSelector) return;

    const hiddenInputs = Array.from(hiddenSelector.querySelectorAll('input[type="radio"]'));
    const matchingInput = hiddenInputs.find((input) => {
      const parts = input.value.split(separator);
      if (parts.length < 2) return false;
      const p1 = parts[0].trim();
      const p2 = parts.slice(1).join(separator).trim();
      return p1 === primaryValue && p2 === secondaryValue;
    });

    if (matchingInput && !matchingInput.checked) {
      this._recordUserChoice(hiddenSelector);
      matchingInput.checked = true;
      matchingInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  _recordUserChoice(hiddenSelector) {
    const chosen = this.vp.constructor.userChosenOptions;
    const url = this.vp.dataset.url;
    if (!chosen || !url) return;

    chosen.add(`${url}|${hiddenSelector.dataset.option}`);

    const selectors = Array.from(this.vp.optionSelectors || []);
    const index = selectors.indexOf(hiddenSelector);
    if (index === -1) return;
    selectors.slice(index + 1).forEach((el) => {
      if (el.dataset.option) chosen.delete(`${url}|${el.dataset.option}`);
    });
  }
}

function initAllSplitOptionPickers() {
  document.querySelectorAll('variant-picker').forEach((vp) => {
    if (!vp._splitOptionPicker && vp.querySelector('.split-option-ui')) {
      new SplitOptionPicker(vp);
    }
  });
}

customElements.whenDefined('variant-picker').then(() => {
  initAllSplitOptionPickers();
});

document.addEventListener('on:variant:change', (evt) => {
  const vp = evt.target instanceof Element ? evt.target.closest('variant-picker') : null;
  if (vp && !vp._splitOptionPicker && vp.querySelector('.split-option-ui')) {
    new SplitOptionPicker(vp);
  }
});
